export default __webpack_public_path__ + "static/media/editIcon.370817bd.svg";